import React from 'react';
import './LeaderboardButton.css';
import { useGame } from '../utils/GameContext'; 
import { useAudio } from '../utils/AudioContext'; // 1. Import Audio Context
import { playUiHoverSound, playUiConfirmSound } from '../utils/sounds'; // 2. Import Sound helpers
import { Trophy } from 'lucide-react';

function LeaderboardButton({ onClick }) {
    const { gameState } = useGame(); 
    const { sfxMuted } = useAudio(); // 3. Get mute state

    // Hide button if not in the main menu (ready state)
    const isHidden = gameState !== 'ready';

    const handleClick = () => {
        playUiConfirmSound(sfxMuted); // 4. Play confirm on click
        onClick();
    };

    return (
        <button 
            className={`leaderboard-pill-btn ${isHidden ? 'hidden' : ''}`} 
            onClick={handleClick}
            onMouseEnter={() => playUiHoverSound(sfxMuted)} // 5. Play hover
            disabled={isHidden}
        >
            <div className="lb-icon-circle">
                <Trophy size={18} />
            </div>
            <div className="lb-pill-content">
                <span className="lb-pill-label">
                    Leaderboard
                </span>
                <span className="lb-pill-sublabel">
                    World Rankings
                </span>
            </div>
        </button>
    );
}

export default LeaderboardButton;